import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getOrderId = {
  name: "getOrderId" as const,
  input: z.object({
    orderName: z.string().optional(),
    shopifyId: z.string().optional(),
  }),
  output: z.object({ orderId: zExt.objectId() }),
};
